import React, { createContext, useContext, useEffect, useState } from 'react'
import { IntercomProvider } from 'react-use-intercom'

import config from 'config'
import useCustomerSupportWidget from 'hooks/useCustomerSupportWidget'

const { intercom } = config

const CustomerSupportContext = createContext({})

const CustomerSupportProvider = ({ children }) => {
  const [hidden, setHidden] = useState()

  return (
    <CustomerSupportContext.Provider value={{ hidden }}>
      <IntercomProvider appId={intercom.app_id} onHide={() => setHidden(true)}>
        {children}
      </IntercomProvider>
    </CustomerSupportContext.Provider>
  )
}

export const useCustomerSupportUIManager = () => {
  const { hidden } = useContext(CustomerSupportContext)
  const { hide } = useCustomerSupportWidget()

  useEffect(() => {
    if (hidden) {
      hide()
    }
  }, [hidden, hide])
}

export { CustomerSupportProvider, CustomerSupportContext }
